import { render, staticRenderFns } from "./FrontPagination.vue?vue&type=template&id=f374fb5c&scoped=true"
import script from "./FrontPagination.vue?vue&type=script&lang=js"
export * from "./FrontPagination.vue?vue&type=script&lang=js"
import style0 from "./FrontPagination.vue?vue&type=style&index=0&id=f374fb5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f374fb5c",
  null
  
)

export default component.exports